<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/australia')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/australia/eden-valley/henschke')">Henschke</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/australia')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div class="wine-guide-right">
                    <div class="howto-title">Eden Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EdenValley",
        data () {
            return {
                select: { report: 'Please choose', src: '#' },
                items: [
                    { report: 'Henschke', src: '/wine-guide/australia/eden-valley/henschke' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Eden Valley fine wine | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Experience the flavors and beauty of the Eden Valley wine region, located in South Australia. Taste the expertly crafted Riesling, Shiraz, and other varietals that showcase the unique terroirs and rich winemaking heritage of the Eden Valley. Indulge in the essence of Australia\'s winemaking tradition with every sip from the Eden Valley.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
